import React, {useEffect, useState} from "react"
import {useSelector} from "react-redux";
import OrderApprovementComp from "../../shared/OrderApprovmentComp";
import OrderContactDialog from "../../shared/OrderContactDialog";
import {useHistory, useParams} from "react-router-dom";
import ProjectService from "../../services/ProjectService";
import UserService from "../../services/UserService";
import Topbar from "../Topbar/Topbar";
import {Button, Col, Row} from "antd";
import Loader from "@iso/components/utility/loader";
import Modal from "@iso/components/Feedback/Modal";


export default function(props) {

  const history = useHistory();
  let { customer_id, article_ids } = useParams();
  const idToken = useSelector((state) => state.Auth.idToken);
  const [customer, setCustomer] = useState(null);
    const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [approved, setApproved] = useState(false);
  const [declined, setDeclined] = useState(false);
    const [project, setProject] = useState(null);
  const [saveLoading, setsaveLoading] = useState(false);
  const [error, setError] = useState(null);
  const [updatedTimestamp, setUpdatedTimestamp] = useState(new Date().getTime());
  const [validated, setValidated] = useState(false);
  const [contactDialogOpen, setContactDialogOpen] = useState(false);
  const [loggedInContact, setLoggedInContact] = useState(null);

  // When a cockpit session is present, attribute the order to that user.
  useEffect(() => {
    if (idToken) {
      UserService.getMeAsOrderContact()
        .then((contact) => setLoggedInContact(contact || null))
        .catch(() => {});
    }
  }, [idToken]);

  useEffect(() => {
    Promise.all([
      ProjectService
          .getPublicArticle(article_ids)
          .then((p) => {
            if (p && p.length > 0) {
              const requestedIds = article_ids.split(",");
              // Zu Gruppenartikeln liefert der Endpunkt zusaetzlich deren
              // Mitglieder (fromGroup) - die stehen nicht in der URL, gehoeren
              // aber zur Bestellung.
              const arts = p.filter((a) => a && (a.fromGroup === true
                  || (a.Id && requestedIds.includes(a.Id.toString()))
                  || (a.hqId__c && requestedIds.includes(a.hqId__c.toString()))));
              setArticles(arts.map((a) => {
                // Gruppenartikel selbst kosten nichts, ihre prices-Liste ist leer.
                const listPrice = a.prices && a.prices.length > 0 ? a.prices[0].Price : a.Netto;
                const unitPrice = listPrice ? listPrice : 0;
                const description = a.Text ? a.Text : a.Description;
                return {
                  ...a,
                  Amount: a.Amount ? a.Amount : 1,
                  TotalUnitPrice: unitPrice,
                  Text: "<b>"+a.Name+"</b>"+(description ? "<p>"+description+"</p>" : ""),
                  article: a
                }
              }));
            }
          }),
      ProjectService.getPublicCustomer(customer_id)
        .then((p) => {
          if (p && p.length > 0) {
            setCustomer(p[0]);
          }

        })])
        .finally(() => {
          setLoading(false)
        });
  }, [])

  const onCreateOrderDiscard = () => {
    setsaveLoading(true);

    ProjectService.createOrderDiscard({
      customer: customer,
      articles: articles,
    }).then(() => {
      setsaveLoading(false);
      setDeclined(true);
      Modal.info({
        title: 'Ihre Bestellung wurde abgelehnt.',
        content: 'Wir bedauern es sehr dass Sie unsere Bestellung nicht beauftragt haben. ',
        okText: 'Ok',
        onOk: () => {

        }

      });

    })
  }

  const setPaymentOption = (product, option) => {
    product.priceOptionId = option.Id;
    product.Amount = option.Amount;
    product.Price = option.Price;
    product.TotalUnitPrice = option.Price;
    setUpdatedTimestamp(new Date().getTime());
  }

  const onCreateOrderApprovement = () => {
    if (!validated) {
      return;
    }
    // No recognised cockpit session -> collect the orderer's contact data first.
    if (!idToken) {
      setContactDialogOpen(true);
      return;
    }
    // Logged in -> attribute the order to the logged-in user (name + email).
    if (loggedInContact) {
      submitApproval(loggedInContact);
      return;
    }
    // Not loaded yet -> fetch on demand, but never block the order on it.
    setsaveLoading(true);
    UserService.getMeAsOrderContact()
      .then((contact) => submitApproval(contact))
      .catch(() => submitApproval());
  }

  const loggedInLabel = loggedInContact
    ? (loggedInContact.name && loggedInContact.email
        ? loggedInContact.name + " (" + loggedInContact.email + ")"
        : (loggedInContact.name || loggedInContact.email))
    : null;

  const submitApproval = (orderContact) => {
    setsaveLoading(true);

    ProjectService.createOrderApprovement({
      customer: customer,
      articles: articles,
      orderContact: orderContact,
    }).then(() => {
      setsaveLoading(false);
      setContactDialogOpen(false);
      setApproved(true);
      Modal.info({
        title: 'Projekt bestellt - Bearbeitung startet',
        content: 'Glückwunsch – Sie haben soeben Ihre Bestellung bei uns aufgegeben. Wir werden uns umgehend bei Ihnen mit den nächsten Schritten melden. In einer E-Mail erhalten Sie nochmals alle Details dieser Bestellung.',
        okText: 'Ok',
        onOk: () => {

        }

      });

    }).catch(() => {
      setsaveLoading(false);
      Modal.error({
        title: 'Bestellung fehlgeschlagen',
        content: 'Ihre Bestellung konnte leider nicht verarbeitet werden. Bitte versuchen Sie es erneut.',
        okText: 'Ok',
      });
    })
  }

  const showPriceInfo = () => {

  }

  return (
    <div>
      {error && <div style={{padding: 20,paddingTop: 20}}>
          <h2>Fehler - nicht erlaubt</h2>
          <div>Das Projekt hat nicht den richtigen Status und besitzt ebenfalls nicht den richtigen Typ.</div>
      </div>}
      {!customer && !error && <Loader />}
      {project && declined && <div className={"order-approved"}>
        <h2>Das Angebot wurde abgelehnt</h2>
        <span>Diese Bestellung wurde bereits abgebrochen, Sie können das Fenster nun schließen.</span>
      </div>}
      {project && approved && <div className={"order-approved"}>
        <h2>Vielen Dank für Ihre Bestellung</h2>
        <span>Diese Bestellung wurde bereits abgesendet, Sie können das Fenster nun schließen.</span>
      </div>}
      {
          <div style={{padding: 20,paddingTop: 20}}>
            <div style={{padding:20, paddingTop: 10, fontSize: 26}}>
              Freigabe unseres Angebots
            </div>
          <Row>
            <Col lg={14} xl={14} md={24} sm={24} xs={24}>
                  <div  style={{paddingLeft: 20}}>
                    Auf dieser Seite können Sie Ihr Projekt bei uns bestellen und somit direkt die Bearbeitung beauftragen.
                  </div>
                  <div  style={{padding:20}}>
                    {loading && <Loader />}
                    {(!loading) &&
                        <OrderApprovementComp customer={customer}
                                              updatedTimestamp={updatedTimestamp}
                                              projectId={"xxx"}
                                              onChecked={(val) => {setValidated(val)}}
                                              setPaymentOption={setPaymentOption} approved={approved}
                                              validated={validated}
                                              project={{
                                                quotations: [{
                                                  positions: articles,
                                                }]
                                              }} /> }
                  </div>

            </Col>
            <Col lg={8} xl={8} md={24} sm={24}>
              <div style={{padding: 20}}>
                <div style={{paddingTop: 0}}>
                  <div style={{fontWeight: "bold", marginBottom: 10, fontSize: 16}}>Kundendaten</div>
                  <div dangerouslySetInnerHTML={{__html: customer?.Name}}></div>
                  <div>{customer?.DefaultAddress?.ZipCode + " " + customer?.DefaultAddress?.City}</div>
                  <div><span dangerouslySetInnerHTML={{__html: customer?.DefaultAddress?.Street}} /> {customer?.DefaultAddress?.HouseNumber}</div>
                </div>
                <div style={{paddingTop: 20}}>
                  <div style={{fontWeight: "bold", marginBottom: 10, fontSize: 16}}>Auftragnehmer</div>
                    <div style={{marginTop: "20px"}}>
                        <div>Agentur ID GmbH</div>
                      <div>Ansprechpartner Ida Härtel</div>
                      <div>Tiefenbachstraße 59</div>
                        <div>72622 Nürtingen</div>
                      <div>anfrage@agentur-id.de</div>
                      <br/>
                    </div>
                </div>
              </div>
            </Col>
          </Row>
            <Button size={"large"} loading={saveLoading} disabled={approved || !validated || declined} onClick={onCreateOrderApprovement} style={{marginTop: 20, marginLeft: 20}} type={"primary"}>Kostenpflichtig bestellen</Button>
            <Button size={"large"} style={{marginLeft: 20}} disabled={saveLoading || declined || approved} onClick={onCreateOrderDiscard} type={"secondary"}>Ablehnen</Button>
            {loggedInLabel && <div style={{marginTop: 10, marginLeft: 20, color: "#888"}}>Bestellen als: {loggedInLabel}</div>}
          </div>}

      <OrderContactDialog open={contactDialogOpen}
                          loading={saveLoading}
                          defaultCompany={customer?.Name}
                          onConfirm={submitApproval}
                          onCancel={() => setContactDialogOpen(false)} />

    </div>


  )
}
